import { notifications } from '~/app/notifications'
import AppButton from '@theme/components/atom/AppButton'
import InjectValidator from '~/app/InjectValidator'
import LoadingMixin from '~/mixins/LoadingMixin'

export default {
  mixins: [InjectValidator, LoadingMixin],
  components: {
    AppButton,
  },
  props: {
    tin: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    tinNormalized() {
      return `${this.tin || ''}`.replace(/\D/g, '')
    },
    isTinValidFormat() {
      return this.tinNormalized.length === 8
    },
  },
  methods: {
    async callAres() {
      if (!this.isTinValidFormat) {
        notifications.warning(this.$t('AresLoading.errors.invalidTin'))
        return
      }

      if (this.$validator && !(await this.$validator.validate('tin'))) {
        return
      }

      this.startLoading()
      try {
        const data = await this.$store.dispatch('user/LOAD_USER_FROM_ARES', {
          tin: this.tinNormalized,
        })
        if (data) {
          await this.$emit('loaded', data)
        } else {
          notifications.warning(this.$t('AresLoading.errors.notFound'))
        }
      } catch (e) {
        notifications.danger(this.$t('AresLoading.errors.unavailable'))
      } finally {
        this.stopLoading()
      }
    },
  },
}
